import { EVENT_TIME_ZONE } from '@koderek/shared';

/** Daty i godziny zawsze w strefie wydarzenia (US-101 AC-6), niezależnie od strefy urządzenia. */
const dateFormat = new Intl.DateTimeFormat('pl-PL', {
  timeZone: EVENT_TIME_ZONE,
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  year: 'numeric',
});
const dateTimeFormat = new Intl.DateTimeFormat('pl-PL', {
  timeZone: EVENT_TIME_ZONE,
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});
const timeFormat = new Intl.DateTimeFormat('pl-PL', { timeZone: EVENT_TIME_ZONE, hour: '2-digit', minute: '2-digit' });

/** `2027-05-15` albo chwila ISO → „sobota, 15 maja 2027”. */
export function formatDate(value: string): string {
  const instant = /^\d{4}-\d{2}-\d{2}$/.test(value) ? new Date(`${value}T12:00:00Z`) : new Date(value);
  return dateFormat.format(instant);
}

export function formatDateTime(iso: string): string {
  return dateTimeFormat.format(new Date(iso));
}

export function formatTime(iso: string): string {
  return timeFormat.format(new Date(iso));
}

/** „Kraków, sobota, 15 maja 2027” – nazwa edycji w komunikatach. */
export function editionLabel(edition: { name: string; city: string }): string {
  return `${edition.name} (${edition.city})`;
}

/**
 * Krótka etykieta miejsca na przyciskach i przełącznikach: samo miasto, a gdy tego samego dnia jest inna edycja w tym mieście –
 * „Miasto · krótka nazwa miejsca” (bez nazwy: adres), żeby przyciski się nie powtarzały (PRD §10 pkt 49).
 */
export function editionPlaceLabel(
  edition: { id: string; date: string; city: string; address: string; placeName: string | null },
  editions: { id: string; date: string; city: string }[],
): string {
  const sameCity = editions.some((o) => o.id !== edition.id && o.date === edition.date && o.city === edition.city);
  return sameCity ? `${edition.city} · ${edition.placeName ?? edition.address}` : edition.city;
}

const dayMonthFormat = new Intl.DateTimeFormat('pl-PL', { timeZone: EVENT_TIME_ZONE, day: 'numeric', month: 'long' });

/** `2027-05-15` → `{ day: '15', month: 'maja' }` – kafelek daty na karcie edycji. */
export function dayAndMonth(date: string): { day: string; month: string } {
  const parts = dayMonthFormat.formatToParts(new Date(`${date}T12:00:00Z`));
  return {
    day: parts.find((p) => p.type === 'day')?.value ?? '',
    month: parts.find((p) => p.type === 'month')?.value ?? '',
  };
}

const calendarFormat = new Intl.DateTimeFormat('pl-PL', {
  timeZone: EVENT_TIME_ZONE,
  weekday: 'long',
  day: 'numeric',
  month: 'short',
  year: 'numeric',
});

/** `2026-09-30` → `{ weekday: 'środa', day: '30', month: 'wrz', year: '2026' }` (skrót – mieści się na każdej kartce) – kartka kalendarza w nagłówku edycji. */
export function calendarParts(date: string): { weekday: string; day: string; month: string; year: string } {
  const parts = calendarFormat.formatToParts(new Date(`${date}T12:00:00Z`));
  const part = (type: Intl.DateTimeFormatPartTypes) => parts.find((p) => p.type === type)?.value ?? '';
  return { weekday: part('weekday'), day: part('day'), month: part('month'), year: part('year') };
}
